import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 171 171",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "171",
      height: "171",
      rx: "85.5",
      fill: "#FA683A",
      "fill-opacity": "0.1"
    }, null, -1),
    _createElementVNode("path", {
      d: "M85.5 171C96.728 171 107.846 168.788 118.219 164.492C128.593 160.195 138.018 153.897 145.958 145.958C153.897 138.018 160.195 128.593 164.492 118.219C168.788 107.846 171 96.728 171 85.5C171 74.272 168.788 63.1539 164.492 52.7806C160.195 42.4072 153.897 32.9818 145.958 25.0424C138.018 17.103 128.593 10.8051 118.219 6.5083C107.846 2.21152 96.728 -4.90792e-07 85.5 0V34.2C92.2368 34.2 98.9077 35.5269 105.132 38.105C111.356 40.683 117.011 44.4618 121.775 49.2254C126.538 53.9891 130.317 59.6443 132.895 65.8683C135.473 72.0923 136.8 78.7632 136.8 85.5C136.8 92.2368 135.473 98.9077 132.895 105.132C130.317 111.356 126.538 117.011 121.775 121.775C117.011 126.538 111.356 130.317 105.132 132.895C98.9077 135.473 92.2368 136.8 85.5 136.8V171Z",
      fill: "#D25B36"
    }, null, -1),
    _createElementVNode("rect", {
      x: "0.5",
      y: "0.5",
      width: "170",
      height: "170",
      rx: "85",
      stroke: "#E66138",
      "stroke-opacity": "0.3"
    }, null, -1)
  ]))]))
}
export default { render: render }